/**
 * BrandShowcase Component
 * Display brand logos and product info
 */

import { motion } from 'motion/react';

const brands = [
  {
    name: 'Jabra',
    description: 'Professional audio solutions',
    logoText: 'JABRA',
    href: '/collections/jabra',
  },
  {
    name: 'Poly',
    description: 'Professional-grade communication',
    logoText: 'Poly',
    href: '/collections/poly',
  },
  {
    name: 'Axtel',
    description: 'Affordable quality headsets',
    logoText: 'AXTEL',
    href: '/collections/axtel',
  },
];


export function BrandShowcase() {
  return (
    <section className="py-20 lg:py-32 bg-surface-coal">
      <div className="container-wide">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-2xs font-mono uppercase tracking-widest text-brand-orange mb-4 block">
            Professional Audio
          </span>
          <h2 className="heading-lg text-accent-white mb-4">
            Brands We Stock
          </h2>
          <p className="text-accent-silver max-w-2xl mx-auto">
            We stock Jabra, Poly, and Axtel headsets,
            offering genuine products with full manufacturer warranties.
          </p>
        </motion.div>

        {/* Brand Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {brands.map((brand, i) => (
            <motion.a
              key={brand.name}
              href={brand.href}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group relative overflow-hidden rounded-2xl border border-surface-slate bg-surface-graphite p-8 text-center transition-all duration-300 hover:border-brand-orange hover:shadow-glow-orange"
            >
              {/* Logo */}
              <div className="mb-6">
                <span className="font-display font-bold text-4xl text-accent-white group-hover:text-brand-orange transition-colors">
                  {brand.logoText}
                </span>
              </div>

              <p className="text-accent-silver text-sm mb-6">{brand.description}</p>

              <span className="inline-flex items-center gap-2 text-sm text-brand-orange">
                Shop {brand.name}
                <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>

              {/* Decorative corner */}
              <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-brand-orange/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.a>
          ))}
        </div>

      </div>
    </section>
  );
}
